class PerfilUsuario extends HTMLElement {
  // CONSTRUCTOR Y PROPIEDADES
  constructor() {
    super();
    this.ordenes = [];
    this.ordenesFiltradas = [];
    this.filtroActual = 'todo';
    this.paginaActual = 1;
    this.ordenesPorPagina = 10;
    this.usuario = JSON.parse(localStorage.getItem('ph-datos-usuario')) || null;
  }

  // INICIALIZACIÓN PRINCIPAL
  async connectedCallback() {
    this.inicializarReferenciasDOM();
    this.configurarEventos();
    this.inicializarUI();
    this.inicializarDatosAlmacenados();
    this.verificarPermisoNotificaciones();
    await this.cargarOrdenes();
  }

  // REFERENCIAS A ELEMENTOS DOM
  inicializarReferenciasDOM() {
    // Referencias generales
    this.etiquetaTituloMobil = this.querySelector('#phppu-headerm-titulo');
    this.menuGeneralSector = document.getElementById('phppu-menu-general');
    this.menuGeneralBody = document.getElementById('phppu-menu-general-body');
    this.ordenesHTML = this.querySelector('#seccion-ordenes');
    this.navegacionPaginacion = this.querySelector('.phpp-hp-navegacion-items');

    // Referencias móvil
    this.headerMobil = document.getElementById('phppu-header-movil');
    this.btnAtrasHeader = document.getElementById('phppu-headerm-atras');
    this.btnMenuHeader = document.getElementById('phppu-headerm-menu');
    this.tituloHeaderMobil = document.getElementById('phppu-headerm-titulo');

    // Referencias desktop - Navegación
    this.btnSectorIPerfil = document.getElementById('phppu-btn-menu-perfil');
    this.btnSectorIHistorial = document.getElementById('phppu-btn-historial');
    this.btnSectorIConfiguraciones = document.getElementById('phppu-btn-configuraciones');

    // Referencias desktop - Secciones
    this.seccionPerfil = document.getElementById('phpp-cd-perfil');
    this.seccionHistorial = document.getElementById('phpp-cd-historial');
    this.seccionConfiguraciones = document.getElementById('phpp-cd-configuraciones');

    // Referencias desktop - Botones de acción
    this.btnCerrarSesion = document.getElementById('phppu-btn-cerrar-sesion');
    this.btnEliminarCuenta = document.getElementById('phppu-btn-eliminar-cuenta');
    this.btnCheckboxEstado = document.querySelector('#phppu-checkbox-estado');

    // Referencias desktop - Labels de perfil
    this.labelNombre = document.querySelector('#phppu-label-nombre');
    this.labelApellido = document.querySelector('#phppu-label-apellido');
    this.labelTelefono = document.querySelector('#phppu-label-telefono');
    this.labelCi = document.querySelector('#phppu-label-ci');
    this.labelCorreo = document.querySelector('#phppu-label-correo');
    this.labelDireccion = document.querySelector('#phppu-label-direccion');

    // Referencias desktop - Botones de políticas y contacto
    this.btnTerminosyCondiciones = this.querySelector('#phppe-terminosycondiciones');
    this.btnPoliticasPrivacidad = this.querySelector('#phppe-politicasdeprivacidad');
    this.btnPoliticasHutCoins = this.querySelector('#phppe-politicasdehutcoins');
    this.btnContactoWhatssap = this.querySelector('#phppe-contactanoswhatssap');
    this.btnCorreo = this.querySelector('#phppe-correo');

    // Referencias desktop - Filtros de historial
    this.btnFiltroTodo = this.querySelector('#todo');
    this.btnFiltroPendiente = this.querySelector('#pendiente');
    this.btnFiltroCancelado = this.querySelector('#cancelado');
    this.btnFiltroPreparado = this.querySelector('#preparado');

    // Referencias desktop - Botones ver detalle (iniciales)
    this.btnsVerDetalle = document.querySelectorAll('#phppu-btn-ver-detalle');
  }

  // CONFIGURACIÓN DE EVENTOS
  configurarEventos() {
    // Eventos de navegación móvil
    this.btnAtrasHeader.addEventListener('click', this.manejarAtrasHeader.bind(this));
    this.btnMenuHeader.addEventListener('click', this.manipulacionContenedorMenu.bind(this));

    // Eventos de navegación desktop
    this.btnSectorIPerfil.addEventListener('click', this.seleccionOpcionMenu.bind(this));
    this.btnSectorIHistorial.addEventListener('click', this.seleccionOpcionMenu.bind(this));
    this.btnSectorIConfiguraciones.addEventListener('click', this.seleccionOpcionMenu.bind(this));

    // Eventos de acciones de cuenta
    this.btnCerrarSesion.addEventListener('click', this.cerrarSesion.bind(this));
    this.btnEliminarCuenta.addEventListener('click', this.eliminarCuenta.bind(this));
    this.btnCheckboxEstado.addEventListener('change', this.solicitarNotificaciones.bind(this));

    // Eventos de políticas y contacto
    this.btnTerminosyCondiciones.addEventListener('click', () => {
      window.open('https://farmacorp.com/policies/privacy-policy', '_blank');
    });
    this.btnPoliticasPrivacidad.addEventListener('click', () => {
      window.open('https://farmacorp.com/policies/privacy-policy', '_blank');
    });
    this.btnPoliticasHutCoins.addEventListener('click', () => {
      window.open('https://www.pizzahut.com.bo/es/Bases_Hut_Coin', '_blank');
    });
    this.btnContactoWhatssap.addEventListener('click', () => {
      window.open('https://wa.me/59178674992', '_blank');
    });
    this.btnCorreo.addEventListener('click', this.manejarCorreo.bind(this));

    // Eventos de botones ver detalle iniciales
    this.btnsVerDetalle.forEach((btn) => {
      btn.addEventListener('click', () => {
        localStorage.setItem('ph-estadoDP', 'etapa-2');
        localStorage.setItem('ph-origenHistorial', 'true');
        window.location.href = '/pages/detalle-pedido';
      });
    });

    // Evento para cerrar menú móvil
    this.detectarClickEspeciales();
  }

  // INICIALIZACIÓN DE UI
  inicializarUI() {
    this.menuGeneralSector.style.display = 'none';
    this.seccionPerfil.style.display = 'none';
    this.seccionHistorial.style.display = 'none';
    this.seccionConfiguraciones.style.display = 'none';
  }

  // GESTIÓN DE DATOS
  async cargarOrdenes() {
    this.mostrarCargando();

    try {
      this.ordenes = await GestionOrdenesShopify.getOrdenesCliente(this.usuario.id);

      if (this.ordenes && this.ordenes.length > 0) {
        this.inicializarFiltros();
        this.aplicarFiltro('todo');
      } else {
        this.ordenesHTML.innerHTML = '<p class="color-letras-extra">No tienes órdenes aún</p>';
        this.ocultarPaginacion();
      }
    } catch (error) {
      console.error('❌ Error obteniendo órdenes:', error);
      this.ordenesHTML.innerHTML = '<p class="color-letras-extra">Error al cargar las órdenes</p>';
      this.ocultarPaginacion();
    }
  }

  inicializarDatosAlmacenados() {
    const datosUsuario = JSON.parse(localStorage.getItem('ph-datos-usuario'));
    const direccion = localStorage.getItem('direccion-cliente');
    const dataPerfil = localStorage.getItem('pg-perfil-opcion');

    console.log('inicializando datos almacenados');

    // Validaciones de seguridad
    if (dataPerfil == null || !datosUsuario) {
      window.location.href = '/';
      return;
    }

    // Configurar sección inicial según localStorage
    if (dataPerfil == 'perfil') {
      this.btnSectorIPerfil.classList.add('seleccionado');
      this.seccionPerfil.style.display = 'flex';
      this.tituloHeaderMobil.innerText = 'MI PERFIL';
    } else if (dataPerfil == 'historial') {
      this.btnSectorIHistorial.classList.add('seleccionado');
      this.tituloHeaderMobil.innerText = 'HISTORIAL DE PEDIDOS';
      this.seccionHistorial.style.display = 'flex';
    } else if (dataPerfil == 'configuracion') {
      this.btnSectorIConfiguraciones.classList.add('seleccionado');
      this.tituloHeaderMobil.innerText = 'CONFIGURACIONES';
      this.seccionConfiguraciones.style.display = 'flex';
    }

    // Cargar datos del usuario en los labels
    if (datosUsuario) {
      this.labelNombre.innerText = datosUsuario.nombre || '----';
      this.labelApellido.innerText = datosUsuario.apellido || '----';
      this.labelTelefono.innerText = datosUsuario.celular || '----';
      this.labelCi.innerText = datosUsuario.ci || '----';
      this.labelCorreo.innerText = datosUsuario.email || '----';
      this.labelDireccion.innerText = direccion || '----';
    }

    // Configurar estado de notificaciones
    const tieneNotifi = localStorage.getItem('ph-notificaciones');
    this.btnCheckboxEstado.checked = tieneNotifi == 'true';
  }

  // FILTROS Y PAGINACIÓN
  inicializarFiltros() {
    this.btnFiltroTodo.addEventListener('click', () => this.aplicarFiltro('todo'));
    this.btnFiltroPendiente.addEventListener('click', () => this.aplicarFiltro('pendiente'));
    this.btnFiltroCancelado.addEventListener('click', () => this.aplicarFiltro('cancelado'));
    this.btnFiltroPreparado.addEventListener('click', () => this.aplicarFiltro('preparado'));
  }

  aplicarFiltro(tipoFiltro) {
    this.filtroActual = tipoFiltro;
    this.paginaActual = 1; // Resetear a primera página al cambiar filtro

    this.actualizarBotonesFiltro(tipoFiltro);
    this.ordenesFiltradas = this.filtrarOrdenes(tipoFiltro);
    this.renderizarOrdenes();
    this.renderizarPaginacion();
  }

  filtrarOrdenes(tipoFiltro) {
    if (tipoFiltro === 'todo') {
      return [...this.ordenes];
    }

    return this.ordenes.filter(orden => {
      const cancelledAt = orden.cancelledAt || null;
      const fulfillmentStatus = orden.displayFulfillmentStatus || '';
      const estado = orden.estado || '';

      switch (tipoFiltro) {
        case 'pendiente':
          return !cancelledAt && (estado !== 'PAID' || fulfillmentStatus === 'UNFULFILLED');
        case 'cancelado':
          return !!cancelledAt;
        case 'preparado':
          return estado === 'PAID' && fulfillmentStatus === 'FULFILLED';
        default:
          return true;
      }
    });
  }

  actualizarBotonesFiltro(tipoFiltro) {
    const botones = {
      todo: this.btnFiltroTodo,
      pendiente: this.btnFiltroPendiente,
      cancelado: this.btnFiltroCancelado,
      preparado: this.btnFiltroPreparado
    };

    Object.values(botones).forEach(btn => btn.classList.remove('seleccionado'));
    if (botones[tipoFiltro]) {
      botones[tipoFiltro].classList.add('seleccionado');
    }
  }

  // RENDERIZADO
  mostrarCargando() {
    this.ordenesHTML.innerHTML = `
      <div class="phpp-cargando-container">
        <div class="phpp-spinner"></div>
        <p class="color-letras-extra">Cargando tus órdenes...</p>
      </div>
    `;
    if (this.navegacionPaginacion) {
      this.navegacionPaginacion.style.display = 'none';
    }
  }

  renderizarOrdenes() {
    this.ordenesHTML.innerHTML = '';

    if (!this.ordenesFiltradas || this.ordenesFiltradas.length === 0) {
      this.ordenesHTML.innerHTML = '<p class="color-letras-extra">No hay órdenes con este filtro</p>';
      this.ocultarPaginacion();
      return;
    }

    // Calcular índices de paginación
    const inicio = (this.paginaActual - 1) * this.ordenesPorPagina;
    const fin = inicio + this.ordenesPorPagina;
    const ordenesPagina = this.ordenesFiltradas.slice(inicio, fin);

    ordenesPagina.forEach((orden) => {
      const ordenHTML = this.generarHTMLOrden(orden);
      this.ordenesHTML.innerHTML += ordenHTML;
    });

    // Agregar event listeners a los botones de ver detalle
    this.configurarEventosVerDetalle();
  }

  generarHTMLOrden(orden) {
    // Obtener información del primer producto
    const primerProducto = orden.line_items && orden.line_items.length > 0
      ? orden.line_items[0]
      : null;
    const nombreProducto = primerProducto ? primerProducto.nombre : 'Pedido';
    const tituloComprimido = nombreProducto.length > 20
      ? nombreProducto.substring(0, 20) + '...'
      : nombreProducto;

    // Determinar estado de la orden
    const { estadoHTML, textoEstado } = this.obtenerEstadoOrden(orden);

    // Formatear fecha
    const fechaFormateada = this.formatearFecha(orden.tiempo_creacion);

    // Obtener número de orden
    const numeroOrden = orden.nro ? orden.nro.replace('#', '') : 'N/A';

    // Obtener imagen del producto
    const imagenProducto = primerProducto?.imagen || window.assets?.imagen_aux || '{{ "imagen-pizza-1.png" | asset_url }}';

    return `
      <div class="phpp-hp-item-dp-cliente" data-orden-id="${orden.id}">
        <div class="phpp-ihpdp-contexto">
          <div class="phpp-hp-item-imgen">
            <img src="${imagenProducto}" alt="${nombreProducto}" width="100%" height="100%">
          </div>
          <div class="phpp-hp-item-info">
            <p>${tituloComprimido}</p>
            <p class="color-letras-extra">ID DE ORDEN #${numeroOrden}</p>
            <div class="phpp-ph-item-estado ${estadoHTML}">
              ${window.shopIcons.icon_disponibilidad}
              <p>${textoEstado}</p>
            </div>
            <p class="color-letras-extra">${fechaFormateada}</p>
          </div>
        </div>
        <div class="phpp-ihpdp-opciones">
          <button class="ph-btn-primario desactivado">
            <p>REPETIR PEDIDO</p>
          </button>
          <button
            class="phppu-btn-ver-detalle ph-btn-secundario"
            data-orden-id="${orden.id || ''}"
            data-orden-nro="${orden.nro || ''}"
          >
            <p>VER DETALLE</p>
          </button>
        </div>
      </div>
    `;
  }

  obtenerEstadoOrden(orden) {
    const fulfillmentStatus = orden.displayFulfillmentStatus || '';
    const cancelledAt = orden.cancelledAt || null;

    if (cancelledAt) {
      return { estadoHTML: 'cancelado', textoEstado: 'CANCELADO' };
    }

    if (orden.estado === 'PAID') {
      if (fulfillmentStatus === 'FULFILLED') {
        return { estadoHTML: 'entregado', textoEstado: 'ENTREGADO' };
      } else if (fulfillmentStatus === 'UNFULFILLED') {
        return { estadoHTML: 'encamino', textoEstado: 'EN CAMINO' };
      } else {
        return { estadoHTML: 'entregado', textoEstado: 'ENTREGADO' };
      }
    }

    return { estadoHTML: 'pendiente', textoEstado: 'PENDIENTE' };
  }

  formatearFecha(tiempoCreacion) {
    const fecha = tiempoCreacion ? new Date(tiempoCreacion) : new Date();
    const dia = String(fecha.getDate()).padStart(2, '0');
    const mes = String(fecha.getMonth() + 1).padStart(2, '0');
    const año = fecha.getFullYear();
    const horas = String(fecha.getHours()).padStart(2, '0');
    const minutos = String(fecha.getMinutes()).padStart(2, '0');
    return `${dia}/${mes}/${año} | ${horas}:${minutos}`;
  }

  configurarEventosVerDetalle() {
    const botonesVerDetalle = this.ordenesHTML.querySelectorAll('.phppu-btn-ver-detalle');
    botonesVerDetalle.forEach((btn) => {
      btn.addEventListener('click', (e) => {
        const ordenId = e.currentTarget.getAttribute('data-orden-id');
        const ordenNro = e.currentTarget.getAttribute('data-orden-nro');

        localStorage.setItem('ph-estadoDP', 'etapa-2');
        localStorage.setItem('ph-origenHistorial', 'true');
        localStorage.setItem('ph-orden-seleccionada', ordenNro);
        localStorage.setItem('ph-id-orden', ordenId);

        if (!localStorage.getItem('ph-dragontail')) {
          localStorage.setItem('ph-dragontail', '');
        }

        window.location.href = '/pages/detalle-pedido';
      });
    });
  }

  renderizarPaginacion() {
    const totalOrdenes = this.ordenesFiltradas.length;
    const totalPaginas = Math.ceil(totalOrdenes / this.ordenesPorPagina);

    if (totalPaginas <= 1) {
      this.ocultarPaginacion();
      return;
    }

    this.mostrarPaginacion();
    this.navegacionPaginacion.innerHTML = '';

    // Botón ANTERIOR
    const btnAnterior = this.crearBotonAnterior(totalPaginas);
    this.navegacionPaginacion.appendChild(btnAnterior);

    // Números de página
    const paginas = this.generarNumerosPagina(totalPaginas);
    paginas.forEach(numero => {
      if (numero === '...') {
        const btnEllipsis = document.createElement('button');
        btnEllipsis.className = 'phpp-ni';
        btnEllipsis.innerHTML = '<p>...</p>';
        btnEllipsis.disabled = true;
        this.navegacionPaginacion.appendChild(btnEllipsis);
      } else {
        const btnPagina = this.crearBotonPagina(numero);
        this.navegacionPaginacion.appendChild(btnPagina);
      }
    });

    // Botón SIGUIENTE
    const btnSiguiente = this.crearBotonSiguiente(totalPaginas);
    this.navegacionPaginacion.appendChild(btnSiguiente);
  }

  crearBotonAnterior(totalPaginas) {
    const btnAnterior = document.createElement('button');
    btnAnterior.className = 'phpp-ni';
    btnAnterior.disabled = this.paginaActual === 1;
    if (this.paginaActual === 1) {
      btnAnterior.classList.add('desactivado');
    }
    btnAnterior.innerHTML = `
      ${window.shopIcons.icon_flecha_derecha_ios}
      <p class="phpp-hpni-especial">ANTERIOR</p>
    `;
    btnAnterior.addEventListener('click', () => {
      if (this.paginaActual > 1) {
        this.paginaActual--;
        this.renderizarOrdenes();
        this.renderizarPaginacion();
      }
    });
    return btnAnterior;
  }

  crearBotonPagina(numero) {
    const btnPagina = document.createElement('button');
    btnPagina.className = 'phpp-ni';
    if (numero === this.paginaActual) {
      btnPagina.classList.add('seleccionado');
    }
    btnPagina.innerHTML = `<p>${numero}</p>`;
    btnPagina.addEventListener('click', () => {
      this.paginaActual = numero;
      this.renderizarOrdenes();
      this.renderizarPaginacion();
    });
    return btnPagina;
  }

  crearBotonSiguiente(totalPaginas) {
    const btnSiguiente = document.createElement('button');
    btnSiguiente.className = 'phpp-ni activo';
    btnSiguiente.disabled = this.paginaActual === totalPaginas;
    if (this.paginaActual === totalPaginas) {
      btnSiguiente.classList.add('desactivado');
    }
    btnSiguiente.innerHTML = `
      ${window.shopIcons.icon_flecha_izquierda_ios}
      <p class="phpp-hpni-especial">SIGUIENTE</p>
    `;
    btnSiguiente.addEventListener('click', () => {
      if (this.paginaActual < totalPaginas) {
        this.paginaActual++;
        this.renderizarOrdenes();
        this.renderizarPaginacion();
      }
    });
    return btnSiguiente;
  }

  generarNumerosPagina(totalPaginas) {
    const paginas = [];
    const paginaActual = this.paginaActual;

    if (totalPaginas <= 7) {
      for (let i = 1; i <= totalPaginas; i++) {
        paginas.push(i);
      }
    } else {
      if (paginaActual <= 3) {
        for (let i = 1; i <= 4; i++) {
          paginas.push(i);
        }
        paginas.push('...');
        paginas.push(totalPaginas);
      } else if (paginaActual >= totalPaginas - 2) {
        paginas.push(1);
        paginas.push('...');
        for (let i = totalPaginas - 3; i <= totalPaginas; i++) {
          paginas.push(i);
        }
      } else {
        paginas.push(1);
        paginas.push('...');
        for (let i = paginaActual - 1; i <= paginaActual + 1; i++) {
          paginas.push(i);
        }
        paginas.push('...');
        paginas.push(totalPaginas);
      }
    }

    return paginas;
  }

  mostrarPaginacion() {
    if (this.navegacionPaginacion) {
      this.navegacionPaginacion.style.display = 'flex';
    }
  }

  ocultarPaginacion() {
    if (this.navegacionPaginacion) {
      this.navegacionPaginacion.style.display = 'none';
    }
  }

  // NAVEGACIÓN Y UI
  seleccionOpcionMenu(event) {
    const botonClickeado = event.currentTarget;

    if (botonClickeado.classList.contains('seleccionado')) {
      return;
    }

    const elementos = [
      { boton: this.btnSectorIPerfil, seccion: this.seccionPerfil },
      { boton: this.btnSectorIHistorial, seccion: this.seccionHistorial },
      { boton: this.btnSectorIConfiguraciones, seccion: this.seccionConfiguraciones },
    ];

    elementos.forEach((elemento) => {
      elemento.boton.classList.remove('seleccionado');
      elemento.seccion.style.display = 'none';
    });

    botonClickeado.classList.add('seleccionado');
    const seccionSeleccionada = elementos.find((elemento) => elemento.boton === botonClickeado)?.seccion;
    if (seccionSeleccionada) {
      this.etiquetaTituloMobil.innerText = botonClickeado.innerText.toUpperCase();
      seccionSeleccionada.style.display = 'flex';
    }
  }

  manipulacionContenedorMenu() {
    if (this.menuGeneralSector.style.display == 'none') {
      this.menuGeneralSector.style.display = 'flex';
    }
  }

  detectarClickEspeciales() {
    const menuGeneralSector = this.menuGeneralSector;
    const menuGeneralBody = this.menuGeneralBody;

    menuGeneralSector.addEventListener('click', (event) => {
      if (event.target === menuGeneralSector && !menuGeneralBody.contains(event.target)) {
        menuGeneralSector.style.display = 'none';
      }
    });
  }

  // MANEJADORES DE EVENTOS
  manejarAtrasHeader() {
    if (history.length <= 1) {
      window.location.href = '/';
    } else {
      history.back();
    }
  }

  manejarCorreo() {
    const email = 'infopizzahut@nexocorp.net';
    const subject = 'Consulta sobre pedido';
    const body = 'Hola, me gustaría hacer una consulta sobre mi pedido...';
    window.location.href = `mailto:${email}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
  }

  // GESTIÓN DE CUENTA
  cerrarSesion() {
    localStorage.removeItem('ph-datos-usuario');
    localStorage.removeItem('pg-perfil-opcion');
    localStorage.removeItem('direccion-cliente');
    window.location.href = '/';
  }

  eliminarCuenta() {
    localStorage.removeItem('ph-datos-usuario');
    localStorage.removeItem('pg-perfil-opcion');
    localStorage.removeItem('direccion-cliente');
    window.location.href = '/';
  }

  // NOTIFICACIONES
  solicitarNotificaciones() {
    if (this.btnCheckboxEstado.checked) {
      if (Notification.permission === 'granted') {
        console.log('Permisos ya estaban aceptados');
        localStorage.setItem('ph-notificaciones', 'true');
        return;
      }

      if (Notification.permission === 'denied') {
        alert(
          'Las notificaciones están bloqueadas. Por favor, habilite los permisos de notificación en la configuración de su navegador para este sitio.'
        );
        this.btnCheckboxEstado.checked = false;
        localStorage.setItem('ph-notificaciones', 'false');
        return;
      }

      Notification.requestPermission()
        .then((permission) => {
          if (permission !== 'granted') {
            this.btnCheckboxEstado.checked = false;
            console.log('Permisos de notificación rechazados por el usuario');
            localStorage.setItem('ph-notificaciones', 'false');
            alert(
              'Para recibir notificaciones importantes, por favor habilite los permisos en la configuración de su navegador.'
            );
          } else {
            console.log('Permisos de notificación aceptados');
            this.btnCheckboxEstado.checked = true;
            localStorage.setItem('ph-notificaciones', 'true');
          }
        })
        .catch((error) => {
          console.error('Error al solicitar permisos:', error);
          this.btnCheckboxEstado.checked = false;
          localStorage.setItem('ph-notificaciones', 'false');
          alert('Ocurrió un error al solicitar permisos de notificación. Por favor, inténtelo nuevamente.');
        });
    } else {
      console.log('Usuario ha desactivado las notificaciones');
      localStorage.setItem('ph-notificaciones', 'false');
    }
  }

  verificarPermisoNotificaciones() {
    const permiso = Notification.permission;

    if (permiso === 'granted') {
      this.btnCheckboxEstado.checked = true;
      localStorage.setItem('ph-notificaciones', 'true');
    } else {
      this.btnCheckboxEstado.checked = false;
      localStorage.setItem('ph-notificaciones', 'false');
    }

    console.log(`Estado actual de permisos de notificación: ${permiso}`);
  }
}

customElements.define('perfil-usuario', PerfilUsuario);